import * as React from 'react'
import { Box } from '@material-ui/core'
import { jt, t } from 'ttag'
import { ROUTES } from '../../common/Routes/routePaths'
import { Card } from '../../components/Card/Card'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import { Lang, Login$Request, LoginMethod, UserProfileDto } from '../../services/api.types'
import './Login.scss'
import Link from '@material-ui/core/Link'
import { Link as RouterLink } from 'react-router-dom'
import YumBack from '../../components/YumBack/YumBack'
import Typography from '@material-ui/core/Typography'
import YumButton from '../../components/YumButton/YumButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import YumTextField from '../../components/YumTextField/YumTextField'
import { ReactComponent as EmailIcon } from '../../assets/v2/icons/email.svg'
import { ReactComponent as EmailFilledIcon } from '../../assets/v2/icons/email-filled.svg'
import { ReactComponent as EmailErrorIcon } from '../../assets/v2/icons/email-error.svg'
import { ReactComponent as LockIcon } from '../../assets/v2/icons/lock.svg'
import { ReactComponent as LockFilledIcon } from '../../assets/v2/icons/lock-filled.svg'
import { ReactComponent as LockErrorIcon } from '../../assets/v2/icons/lock-error.svg'
import { ReactComponent as ErrorIcon } from '../../assets/v2/icons/error.svg'
import { ReactComponent as EditIcon } from '../../assets/icons/pencil.svg'
import { ReactComponent as Visibility } from '../../assets/v2/icons/visibility.svg'
import { ReactComponent as VisibilityOff } from '../../assets/v2/icons/visibility-off.svg'
import { isEmailFieldErrorVisible, isTextFieldErrorVisible } from '../../common/helpers/formHelpers'
import IconButton from '@material-ui/core/IconButton'
import { Tooltip } from '@material-ui/core'
import Loader from '../../components/Loader/Loader'
import YumGoogleSignInWrapper from '../../components/YumGoogleSignIn/YumGoogleSignInWrapper'
import YumAppleSignInWrapper from '../../components/YumAppleSignIn/YumAppleSignInWrapper'
import { currentLang } from '../../i18nInit'
import { WelcomeSidebar } from '../Welcome/Welcome'
import { DesktopSidebar } from '../../components/DesktopSidebar/DesktopSidebar'
import { apiDomain } from '../../services/apiUrl'
import { openUrl } from '../../common/helpers/routeHelpers'
import { isNative } from '../../common/helpers/isNative'
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage'

export interface IStateProps {
  authenticated: boolean
  userDto: UserProfileDto
  isLoginInProgress: boolean
  // SSO email-first flow
  loginStep: 'email' | 'credentials'
  loginMethod: LoginMethod | null
  ssoCompanyId: string | null
  ssoCompanyName: string | null
  ssoConfigId: string | null
  isCheckingLoginMethod: boolean
}

export interface IDispatchProps {
  doLogin(payload: Login$Request): void
  reLocate(): void
  setLoginInProgress(payload: boolean): void
  checkLoginMethod(payload: { email: string }): void
  resetLoginStep(): void
}

type ILoginProps = IStateProps & IDispatchProps

export interface ILoginState {
  password: string
  email: string
  isFormValid: boolean
  isFormSubmitted: boolean
  showPassword: boolean
  errors: object
  focus: object
  [key: string]: any
}

const LoginSidebar = (props: { className?: string }) => {
  const g2ReviewLink =
    'https://www.g2.com/contributor/yuumuuv_amazon20_v?secure%5Bpage_id%5D=yuumuuv_amazon20_v&secure%5Brewards%5D=true&secure%5Btoken%5D=041c9db237fe50a59aed9497f6831c0fb60a8133bbd6b1315684911484978ce5'
  const here = (
    <a key="g2-link" target="_blank" rel="noreferrer" href={g2ReviewLink} className={'link-blue'}>{t`here`}</a>
  )
  return currentLang === Lang.EN ? (
    <Box
      display={{ xs: 'none', md: 'flex' }}
      flexDirection="column"
      justifyContent="center"
      style={{ background: '#F2F2F6', width: '50%' }}
    >
      <div style={{ padding: '100px', textAlign: 'center' }}>
        <Typography variant="h1" style={{ textAlign: 'center' }}>
          {t`Earn a gift card`}
        </Typography>

        <Typography variant="subtitle1" style={{ textAlign: 'center' }}>{t`Let us know how we're doing.`}</Typography>

        <div style={{ marginBottom: '20px' }}>
          <svg width="142" height="183" viewBox="0 0 142 183" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4842_8387)">
              <path d="M12.6758 135.071L72.0521 165.271L129.174 135.071V16.9778H12.6758V135.071Z" fill="white" />
              <path d="M130.376 17.4286L11.4734 137.175L73.1045 167.675L130.376 138.377V17.4286Z" fill="#F2F3F2" />
              <path
                d="M8.76758 56.3423V137.626L10.8721 138.677L70.2484 168.877L72.0522 169.778L73.8561 168.877L131.128 138.677L133.232 137.626V13.0714H8.76758V56.3423ZM12.6759 135.372V16.9778H129.324V135.372L72.0522 165.571L12.6759 135.372Z"
                fill="#DCDEDC"
              />
              <path
                d="M71 18.931C71.6013 18.931 72.2026 18.931 72.8039 19.0813L71 22.5369C68.2943 22.3867 65.8892 24.4901 65.7388 27.1946C65.5885 29.899 67.693 32.3029 70.3988 32.4532H71C72.2026 32.4532 73.4052 32.0024 74.3071 31.2512L76.2612 34.5566C74.758 35.6084 72.9542 36.2093 71 36.2093C66.1898 36.3596 62.1312 32.7537 61.9809 27.9458C61.8305 23.1379 65.4382 19.0813 70.2484 18.931H71ZM77.1632 26.2931L79.418 30.0492L77.1632 33.6552L75.0587 30.0492H70.6994L72.9542 26.2931H77.1632ZM73.5555 24.9409C73.5555 24.3399 73.7058 23.7389 74.0064 23.2882C74.3071 22.8374 74.9084 22.3867 75.3593 22.0862L75.66 21.9359C76.2612 21.6355 76.4116 21.4852 76.4116 21.1847C76.4116 20.8842 75.9606 20.5837 75.66 20.5837C75.0587 20.5837 74.6077 20.8842 74.3071 21.4852L73.5555 20.734C73.7058 20.4335 74.0064 20.133 74.3071 19.8325C74.758 19.532 75.209 19.532 75.66 19.532C76.1109 19.532 76.7122 19.6822 77.0128 19.9827C77.3135 20.2832 77.6141 20.734 77.6141 21.1847C77.6141 21.9359 77.1632 22.5369 76.2612 22.8374L75.8103 23.1379C75.3593 23.4384 75.0587 23.5887 74.9084 24.0394H77.6141V25.0911L73.5555 24.9409ZM71 43.7217L85.2804 35.6084V13.0714H56.5693V35.4581L71 43.7217Z"
                fill="#FF492C"
              />
              <path
                d="M35.5246 73.7709V60.5493C35.5246 60.399 35.6749 60.2488 35.8252 60.2488H39.2826C39.4329 60.2488 39.5832 60.399 39.5832 60.5493V73.7709C39.5832 75.7241 40.9361 77.2266 43.0406 77.2266C45.1451 77.2266 46.4979 75.8744 46.4979 73.7709V60.5493C46.4979 60.399 46.6483 60.2488 46.7986 60.2488H50.2559C50.4063 60.2488 50.5566 60.399 50.5566 60.5493V73.7709C50.5566 77.9778 47.5502 80.6823 43.0406 80.6823C38.531 80.6823 35.5246 77.8276 35.5246 73.7709ZM53.112 76.3251V76.0246C53.112 75.8744 53.2623 75.7242 53.4127 75.7242H56.5694C56.7197 75.7242 56.87 75.8744 56.87 76.0246C56.87 76.9261 57.9223 77.5271 59.4255 77.5271C60.7783 77.5271 61.6803 76.9261 61.6803 76.1749C61.6803 74.9729 59.4255 74.9729 57.321 74.2217C55.3668 73.6207 53.2623 72.569 53.2623 70.0148C53.2623 67.1601 55.6675 65.3572 59.4255 65.3572C63.1835 65.3572 65.5886 67.3104 65.5886 70.0148C65.5886 70.165 65.4382 70.3153 65.2879 70.3153H62.1312C61.9809 70.3153 61.8306 70.165 61.8306 70.0148C61.8306 69.1133 60.9287 68.5123 59.4255 68.5123C58.2229 68.5123 57.321 68.9631 57.321 69.8645C57.321 71.0665 59.2751 71.0665 61.5299 71.8177C63.7847 72.4187 66.0395 73.4705 66.0395 76.1749C66.0395 79.0296 63.4841 80.6823 59.7261 80.6823C55.6675 80.6823 53.112 78.8793 53.112 76.3251ZM81.5225 73.9212C81.5225 74.2217 81.3722 74.2217 81.0715 74.2217H72.0523C71.902 74.2217 71.902 74.2217 71.902 74.3719C71.902 74.8227 72.0523 75.1232 72.2026 75.5739C72.6536 76.6256 73.5555 77.2266 75.209 77.2266C76.5619 77.2266 77.4638 76.6256 78.2154 75.7242C78.3657 75.5739 78.5161 75.4237 78.6664 75.7242L80.7709 77.8276C80.9212 77.9778 80.9212 78.1281 80.7709 78.2783C79.418 79.931 77.3135 80.8325 74.9084 80.8325C71.6014 80.8325 69.3466 79.1798 68.2943 76.4754C67.8434 75.4237 67.693 74.3719 67.693 72.8695C67.693 71.8177 67.8434 70.766 68.144 69.8645C69.0459 67.1601 71.3007 65.3572 74.4574 65.3572C78.3657 65.3572 80.7709 67.9113 81.2218 71.5173C81.5225 72.2685 81.5225 73.0197 81.5225 73.9212ZM72.2026 70.4655C72.0523 70.766 72.0523 71.0665 72.0523 71.367C72.0523 71.5173 72.0523 71.5173 72.2026 71.5173H77.1632C77.3135 71.5173 77.3135 71.5173 77.3135 71.367C77.3135 71.0665 77.1632 70.766 77.1632 70.6158C76.8626 69.4138 75.9606 68.8128 74.6078 68.8128C73.4052 68.8128 72.6536 69.4138 72.2026 70.4655ZM93.2474 65.8079C93.3977 65.9581 93.3977 66.1084 93.3977 66.2586L92.7965 69.5641C92.7965 69.8645 92.6461 69.8645 92.3455 69.7143C91.8945 69.5641 91.2933 69.5641 90.692 69.5641C89.3391 69.7143 88.1365 70.6158 88.1365 72.1182V80.0813C88.1365 80.2315 87.9862 80.3818 87.8359 80.3818H84.3785C84.2282 80.3818 84.0779 80.2315 84.0779 80.0813V65.9581C84.0779 65.8079 84.2282 65.6576 84.3785 65.6576H87.8359C87.9862 65.6576 88.1365 65.8079 88.1365 65.9581V67.0099C88.1365 67.1601 88.2869 67.1601 88.2869 67.1601C89.0385 66.1084 90.0907 65.3572 91.4436 65.3572C92.3455 65.3572 92.7965 65.5074 93.2474 65.8079ZM94.45 76.3251V76.0246C94.45 75.8744 94.6003 75.7242 94.7506 75.7242H97.9073C98.0577 75.7242 98.208 75.8744 98.208 76.0246C98.208 76.9261 99.2602 77.5271 100.763 77.5271C102.116 77.5271 103.018 76.9261 103.018 76.1749C103.018 74.9729 100.763 74.9729 98.6589 74.2217C96.7048 73.6207 94.6003 72.569 94.6003 70.0148C94.6003 67.1601 97.0054 65.3572 100.763 65.3572C104.521 65.3572 106.927 67.3104 106.927 70.0148C106.927 70.165 106.776 70.3153 106.626 70.3153H103.469C103.319 70.3153 103.169 70.165 103.169 70.0148C103.169 69.1133 102.267 68.5123 100.763 68.5123C99.5608 68.5123 98.6589 68.9631 98.6589 69.8645C98.6589 71.0665 100.613 71.0665 102.868 71.8177C105.123 72.4187 107.377 73.4705 107.377 76.1749C107.377 79.0296 104.822 80.6823 101.064 80.6823C97.0054 80.6823 94.45 78.8793 94.45 76.3251ZM22.4468 104.421V84.8892C22.4468 84.7389 22.5971 84.5887 22.7474 84.5887H26.2048C26.3551 84.5887 26.5054 84.7389 26.5054 84.8892V101.116C26.5054 101.266 26.5054 101.266 26.6557 101.266H36.1259C36.2762 101.266 36.4265 101.416 36.4265 101.567V104.421C36.4265 104.571 36.2762 104.722 36.1259 104.722H22.7474C22.5971 104.722 22.4468 104.571 22.4468 104.421ZM38.8316 100.214C38.531 99.3128 38.3807 98.2611 38.3807 97.2094C38.3807 96.1576 38.531 94.9557 38.8316 94.2044C39.7336 91.3498 42.1387 89.6971 45.4457 89.6971C48.6024 89.6971 51.0075 91.5 51.9095 94.2044C52.2101 95.1059 52.3604 96.1576 52.3604 97.2094C52.3604 98.2611 52.2101 99.3128 51.9095 100.064C51.0075 103.069 48.6024 104.872 45.4457 104.872C42.1387 105.022 39.5832 103.219 38.8316 100.214ZM48.0011 99.3128C48.1515 98.7118 48.3018 97.9606 48.3018 97.3596C48.3018 96.6084 48.1515 95.8572 48.0011 95.2562C47.5502 93.904 46.6483 93.1527 45.4457 93.1527C44.0928 93.1527 43.1909 93.904 42.8903 95.2562C42.5896 95.7069 42.5896 96.4581 42.5896 97.3596C42.5896 98.1109 42.5896 98.8621 42.74 99.3128C43.1909 100.665 44.0928 101.416 45.4457 101.416C46.6483 101.567 47.5502 100.665 48.0011 99.3128ZM57.9223 104.421L53.2623 90.1478C53.112 89.8473 53.2623 89.6971 53.563 89.6971H57.321C57.4713 89.6971 57.6216 89.8473 57.7719 89.9976L60.1771 98.7118C60.1771 98.8621 60.3274 98.8621 60.3274 98.7118L62.7325 89.9976C62.7325 89.8473 62.8828 89.6971 63.1835 89.6971H66.9414C67.2421 89.6971 67.3924 89.8473 67.2421 90.1478L62.5822 104.271C62.5822 104.421 62.4319 104.571 62.1312 104.571H58.3732C58.0726 104.722 57.9223 104.722 57.9223 104.421ZM81.6728 98.2611C81.6728 98.5616 81.5225 98.5616 81.2218 98.5616H72.2026C72.0523 98.5616 72.0523 98.5616 72.0523 98.7118C72.0523 99.1626 72.2026 99.4631 72.353 99.9138C72.8039 100.966 73.7058 101.567 75.3594 101.567C76.7122 101.567 77.6142 100.966 78.3657 100.064C78.5161 99.9138 78.6664 99.7636 78.8167 100.064L80.9212 102.167C81.0715 102.318 81.0715 102.468 80.9212 102.618C79.5683 104.271 77.4638 105.172 75.0587 105.172C71.7517 105.172 69.4969 103.52 68.4446 100.815C67.9937 99.7636 67.8434 98.7118 67.8434 97.2094C67.8434 96.1576 67.9937 95.1059 68.2943 94.2044C69.1962 91.5 71.451 89.6971 74.6078 89.6971C78.5161 89.6971 80.9212 92.2512 81.3721 95.8572C81.6728 96.6084 81.6728 97.3596 81.6728 98.2611ZM72.353 94.8054C72.2026 95.1059 72.2026 95.4064 72.2026 95.7069C72.2026 95.8572 72.2026 95.8572 72.353 95.8572H77.3135C77.4638 95.8572 77.4638 95.8572 77.4638 95.7069C77.4638 95.4064 77.3135 95.1059 77.3135 94.9557C77.0129 93.7537 76.111 93.1527 74.7581 93.1527C73.4052 93.1527 72.6536 93.7537 72.353 94.8054ZM90.0907 98.1109V84.8892C90.0907 84.7389 90.241 84.5887 90.3913 84.5887H93.8487C93.999 84.5887 94.1493 84.7389 94.1493 84.8892V98.1109C94.1493 100.064 95.5022 101.567 97.6067 101.567C99.7112 101.567 101.064 100.214 101.064 98.1109V84.8892C101.064 84.7389 101.214 84.5887 101.365 84.5887H104.822C104.972 84.5887 105.123 84.7389 105.123 84.8892V98.1109C105.123 102.318 102.116 105.022 97.6067 105.022C93.0971 105.022 90.0907 102.168 90.0907 98.1109ZM107.678 100.665V100.365C107.678 100.214 107.828 100.064 107.979 100.064H111.135C111.286 100.064 111.436 100.214 111.436 100.365C111.436 101.266 112.488 101.867 113.992 101.867C115.344 101.867 116.246 101.266 116.246 100.515C116.246 99.3128 113.992 99.3128 111.887 98.5616C109.933 97.9606 107.828 96.9089 107.828 94.3547C107.828 91.5 110.234 89.6971 113.992 89.6971C117.75 89.6971 120.155 91.6503 120.155 94.3547C120.155 94.5049 120.004 94.6552 119.854 94.6552H116.697C116.547 94.6552 116.397 94.5049 116.397 94.3547C116.397 93.4532 115.495 92.8522 113.992 92.8522C112.789 92.8522 111.887 93.303 111.887 94.2044C111.887 95.4064 113.841 95.4064 116.096 96.1576C118.351 96.7586 120.606 97.8104 120.606 100.515C120.606 103.369 118.05 105.022 114.292 105.022C110.234 105.022 107.678 103.219 107.678 100.665Z"
                fill="#252530"
              />
              <path
                d="M29.5117 122H59.5757V123.203H29.5117V122ZM83.3262 122H113.39V123.203H83.3262V122Z"
                fill="#DCDEDC"
              />
              <path
                d="M64.2356 120.648L68.8955 119.897L71.3006 115.239L73.5554 119.746L78.516 120.648L75.0586 124.103L75.8102 129.062L71.3006 126.958L66.791 129.062L67.3923 124.103L64.2356 120.648Z"
                fill="#DCDEDC"
              />
            </g>
            <defs>
              <clipPath id="clip0_4842_8387">
                <rect width="141" height="183" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <Typography
          variant="subtitle1"
          style={{ textAlign: 'center' }}
        >{jt`Click ${here}, leave a review, and receive $20 gift card as a thank-you.`}</Typography>
      </div>
    </Box>
  ) : (
    /*<div className={props.className || 'login__sidebar'} />*/
    <DesktopSidebar />
  )
}

export class Login extends React.Component<ILoginProps, ILoginState> {
  state = {
    email: '',
    password: '',
    isFormValid: true,
    isFormSubmitted: false,
    showPassword: false,
    errors: {
      email: false,
      password: false,
    },
    focus: {
      email: false,
      password: false,
    },
    isSubmitInProgress: false,
    // True after the user clicks an SSO button -- keeps it disabled with a loader
    // while we redirect to the IdP, since openUrl doesn't navigate the SPA on native.
    isSsoRedirecting: false,
    // For SSO_OR_PASSWORD: which option is currently shown ('sso' or 'password')
    ssoOrPasswordMode: 'sso' as 'sso' | 'password',
  }

  componentDidMount() {
    //document.body.classList.add('show-illustration')
    this.props.reLocate()
    this.props.setLoginInProgress(false)
    // Always start fresh on the email step when the login page loads
    this.props.resetLoginStep()
  }

  /*componentWillUnmount(): void {
    document.body.classList.remove('show-illustration')
  }*/

  componentDidUpdate() {
    if (this.props.authenticated) {
      this.props.reLocate()
    }
  }

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target
    this.setState({ [name]: value }, () => {
      this.validateField(name, value)
      this.setState({ isFormValid: this.isFormValid() })
    })
  }

  validateField = async (name: string, value: string) => {
    let error
    switch (name) {
      case 'email':
        error = isEmailFieldErrorVisible(value)
        break
      case 'password':
        error = isTextFieldErrorVisible(value)
        break
    }
    await this.setState({
      errors: { ...this.state.errors, [name]: error },
    })
    await this.setState({
      isFormValid: this.isFormValid(),
    })
  }

  handleKeyPress = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      // @ts-ignore
      event.target.blur()
      // If on email step, check login method; otherwise submit login
      if (this.props.loginStep === 'email') {
        await this.onEmailSubmit()
      } else {
        await this.onPasswordSubmit()
      }
    }
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  handleMouseDownPassword = (event: any) => {
    event.preventDefault()
  }

  handleFocus = (name: string) => {
    this.setState({ focus: { ...this.state.focus, [name]: true } })
  }

  handleBlur = (name: string) => {
    this.setState({ focus: { ...this.state.focus, [name]: false } })
  }

  isFormValid = () => !Object.values(this.state.errors).some(Boolean)

  /**
   * Step 1: user submits their email.
   * Calls checkLoginMethod to determine what happens next.
   */
  onEmailSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault()
    }
    await this.setState({ isFormSubmitted: true })
    await this.validateField('email', this.state.email)

    if (!this.state.errors.email) {
      this.props.checkLoginMethod({ email: this.state.email })
    }
  }

  /**
   * Step 2: user submits their password (for PASSWORD or SSO_OR_PASSWORD flows).
   */
  onPasswordSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault()
    }
    await this.setState({ isFormSubmitted: true })
    await this.validateField('email', this.state.email)
    await this.validateField('password', this.state.password)

    if (this.state.isFormValid) {
      await this.props.doLogin(this.state)
    }
  }

  /**
   * Go back to email step (user clicks the edit icon on the email field).
   */
  handleBackToEmail = () => {
    this.props.resetLoginStep()
    this.setState(
      {
        password: '',
        isFormSubmitted: false,
        errors: { ...this.state.errors, password: false },
      },
      () => {
        // Focus the email input after the field is re-enabled
        const emailInput = document.querySelector('input[name="email"]') as HTMLInputElement
        if (emailInput) {
          emailInput.focus()
        }
      },
    )
  }

  /**
   * Redirect to the SSO IdP login page via Spring Security's SAML endpoint.
   */
  handleSsoRedirect = () => {
    if (this.state.isSsoRedirecting) return
    const { ssoConfigId, ssoCompanyId } = this.props
    // Use ssoConfigId for SAML redirect (new 1:N model), fall back to ssoCompanyId for backward compat
    const redirectId = ssoConfigId || ssoCompanyId
    if (redirectId) {
      this.setState({ isSsoRedirecting: true })
      const email = this.state.email
      const params = new URLSearchParams()
      if (email) params.set('login_hint', email)
      if (isNative()) params.set('native', 'true')
      const queryString = params.toString()
      const ssoUrl = `${apiDomain}/saml2/authenticate/${redirectId}${queryString ? `?${queryString}` : ''}`
      openUrl(ssoUrl)
    }
  }

  /**
   * Renders the email input field (shown on both steps, disabled on step 2).
   */
  renderEmailField = () => {
    const emailNotEmpty = !!this.state.email
    const isOnCredentialsStep = this.props.loginStep === 'credentials'

    // End adornment: show error tooltip on email step, edit button on credentials step
    let endAdornment: React.ReactNode = ''
    if (this.state.errors.email) {
      endAdornment = (
        <InputAdornment position="end">
          <Tooltip
            title={t`Something is wrong with this email`}
            placement="top-end"
            open={emailNotEmpty && !this.state.focus.email}
            arrow
          >
            <ErrorIcon />
          </Tooltip>
        </InputAdornment>
      )
    } else if (isOnCredentialsStep) {
      // Show edit icon so user can go back and change their email
      endAdornment = (
        <InputAdornment position="end">
          <IconButton aria-label="edit email" onClick={this.handleBackToEmail} edge="end">
            <EditIcon width={24} height={24} />
          </IconButton>
        </InputAdornment>
      )
    }

    return (
      <YumTextField
        placeholder={t`Email`}
        type="email"
        name="email"
        autoComplete="username"
        value={this.state.email}
        onChange={this.handleInputChange}
        onKeyDown={this.handleKeyPress}
        error={this.state.errors.email}
        onFocus={() => this.handleFocus('email')}
        onBlur={() => this.handleBlur('email')}
        disabled={isOnCredentialsStep}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {this.state.errors.email && !this.state.focus.email ? (
                <EmailErrorIcon />
              ) : emailNotEmpty || this.state.focus.email ? (
                <EmailFilledIcon />
              ) : (
                <EmailIcon />
              )}
            </InputAdornment>
          ),
          endAdornment,
        }}
      />
    )
  }

  /**
   * Renders the password field (only shown when loginMethod includes password).
   */
  renderPasswordField = () => {
    const passwordNotEmpty = !!this.state.password

    return (
      <YumTextField
        placeholder={t`Password`}
        type={this.state.showPassword ? 'text' : 'password'}
        name="password"
        autoComplete="current-password"
        error={this.state.errors.password}
        onChange={this.handleInputChange}
        onKeyDown={this.handleKeyPress}
        onFocus={() => this.handleFocus('password')}
        onBlur={() => this.handleBlur('password')}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {this.state.errors.password && !this.state.focus.password ? (
                <LockErrorIcon />
              ) : passwordNotEmpty || this.state.focus.password ? (
                <LockFilledIcon />
              ) : (
                <LockIcon />
              )}
            </InputAdornment>
          ),
          endAdornment: this.state.errors.password ? (
            <InputAdornment position="end">
              <ErrorIcon />
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={this.handleClickShowPassword}
                onMouseDown={this.handleMouseDownPassword}
                edge="end"
              >
                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    )
  }

  /**
   * Step 1: only email input + Continue button.
   */
  renderEmailStep = () => {
    return (
      <form className="login__form" onSubmit={this.onEmailSubmit} noValidate>
        <Typography className={'h1-desktop'} variant="h1">
          {t`Log in to your
    YuMuuv account`}
        </Typography>
        {this.renderEmailField()}
        <YumButton
          type="submit"
          showLoader={true}
          disabled={this.props.isCheckingLoginMethod}
          style={{ marginBottom: 8 }}
        >
          {t`Continue`}
        </YumButton>
        <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
          <Box p="6px 15px 8px 15px">
            <Link component={RouterLink} to={ROUTES.SIGNUP.to}>{t`Don't have an account? Sign up`}</Link>
          </Box>
        </Box>
        <div className={'text-center'}>
          <div className={'or-line'}>
            <span className={'or-line-inner'}>{t`or`}</span>
          </div>
          <YumAppleSignInWrapper buttonText={t`Sign in with Apple`} isSignUp={false} />
          <YumGoogleSignInWrapper buttonText={t`Sign in with Google`} isSignUp={false} />
        </div>
      </form>
    )
  }

  /**
   * Step 2 for PASSWORD: show password field, login button, forgot password, social logins.
   */
  renderPasswordStep = () => {
    return (
      <form className="login__form" onSubmit={this.onPasswordSubmit} noValidate>
        <Typography className={'h1-desktop'} variant="h1">
          {t`Log in to your
    YuMuuv account`}
        </Typography>
        {this.renderEmailField()}
        {this.renderPasswordField()}
        <YumButton type="submit" showLoader={true} disabled={this.props.isLoginInProgress} style={{ marginBottom: 8 }}>
          {t`Log in`}
        </YumButton>
        <Box display="flex" justifyContent="center">
          <Box p="6px 15px 8px 15px">
            <Link
              component={RouterLink}
              to={{ pathname: ROUTES.FORGOT_PASSWORD.to, state: { email: this.state.email } }}
            >{t`Forgot password?`}</Link>
          </Box>
        </Box>
      </form>
    )
  }

  /**
   * Step 2 for SSO_REQUIRED: show company name and SSO button only.
   */
  renderSsoRequiredStep = () => {
    const { ssoCompanyName } = this.props

    return (
      <form className="login__form" onSubmit={(e) => e.preventDefault()} noValidate>
        <Typography className={'h1-desktop'} variant="h1">
          {t`Log in to your
    YuMuuv account`}
        </Typography>
        {this.renderEmailField()}
        {/* Info message about SSO requirement */}
        <Box style={{ marginBottom: 16, textAlign: 'center' }}>
          <Typography variant="body2" style={{ color: '#666' }}>
            {/*{ssoCompanyName
              ? t`${ssoCompanyName} requires single sign-on (SSO) to log in.`
              : t`Your organization requires single sign-on (SSO) to log in.`}*/}
            {t`Your organization requires log in using single sign-on (SSO).`}
          </Typography>
        </Box>
        <YumButton
          onClick={this.handleSsoRedirect}
          showLoader={true}
          disabled={this.state.isSsoRedirecting}
          style={{ marginBottom: 8 }}
        >
          {t`Log in with SSO`}
        </YumButton>
      </form>
    )
  }

  /**
   * Step 2 for SSO_OR_PASSWORD: show SSO or password, with a link to switch between them.
   * Defaults to showing the SSO button first.
   */
  renderSsoOrPasswordStep = () => {
    const showPassword = this.state.ssoOrPasswordMode === 'password'

    return (
      <form
        className="login__form"
        onSubmit={showPassword ? this.onPasswordSubmit : (e) => e.preventDefault()}
        noValidate
      >
        <Typography className={'h1-desktop'} variant="h1">
          {t`Log in to your
    YuMuuv account`}
        </Typography>
        {this.renderEmailField()}
        {showPassword ? (
          <>
            {/* Password mode: show password field + login button */}
            {this.renderPasswordField()}
            <YumButton
              type="submit"
              showLoader={true}
              disabled={this.props.isLoginInProgress}
              style={{ marginBottom: 8 }}
            >
              {t`Log in with password`}
            </YumButton>
            <Box display="flex" justifyContent="center">
              <Box p="6px 15px 8px 15px">
                <Link
                  component={RouterLink}
                  to={{ pathname: ROUTES.FORGOT_PASSWORD.to, state: { email: this.state.email } }}
                >{t`Forgot password?`}</Link>
              </Box>
            </Box>
            {/* Link to switch to SSO */}
            <Box display="flex" justifyContent="center">
              <Box p="6px 15px 8px 15px">
                <Link component="button" type="button" onClick={() => this.setState({ ssoOrPasswordMode: 'sso' })}>
                  {t`Log in with SSO instead`}
                </Link>
              </Box>
            </Box>
            <div className={'text-center'}>
              <div className={'or-line'}>
                <span className={'or-line-inner'}>{t`or`}</span>
              </div>
              <YumAppleSignInWrapper buttonText={t`Sign in with Apple`} isSignUp={false} />
              <YumGoogleSignInWrapper buttonText={t`Sign in with Google`} isSignUp={false} />
            </div>
          </>
        ) : (
          <>
            {/* SSO mode: show SSO button + link to switch to password */}
            <YumButton
              onClick={this.handleSsoRedirect}
              showLoader={true}
              disabled={this.state.isSsoRedirecting}
              style={{ marginBottom: 8 }}
            >
              {t`Log in with SSO`}
            </YumButton>
            {/* Link to switch to password */}
            <Box display="flex" justifyContent="center">
              <Box p="6px 15px 8px 15px">
                <Link component="button" type="button" onClick={() => this.setState({ ssoOrPasswordMode: 'password' })}>
                  {t`Log in with password instead`}
                </Link>
              </Box>
            </Box>
          </>
        )}
      </form>
    )
  }

  /**
   * Step 2 for ACCOUNT_NOT_FOUND: show message and signup link.
   */
  renderAccountNotFoundStep = () => {
    return (
      <form className="login__form" onSubmit={(e) => e.preventDefault()} noValidate>
        <Typography className={'h1-desktop'} variant="h1">
          {t`Log in to your
    YuMuuv account`}
        </Typography>
        {this.renderEmailField()}
        <Box style={{ marginBottom: 16, marginTop: '-16px', textAlign: 'center' }}>
          <ErrorMessage>{t`No account found with this email address.`}</ErrorMessage>
        </Box>
        <YumButton to={ROUTES.SIGNUP.to} style={{ marginBottom: 8 }}>
          {t`Sign up`}
        </YumButton>
      </form>
    )
  }

  /**
   * Renders the correct step based on loginStep and loginMethod state.
   */
  renderCurrentStep = () => {
    const { loginStep, loginMethod } = this.props

    // Step 1: email input only
    if (loginStep === 'email') {
      return this.renderEmailStep()
    }

    // Step 2: adapt based on loginMethod
    switch (loginMethod) {
      case LoginMethod.PASSWORD:
        return this.renderPasswordStep()
      case LoginMethod.SSO_REQUIRED:
        return this.renderSsoRequiredStep()
      case LoginMethod.SSO_OR_PASSWORD:
        return this.renderSsoOrPasswordStep()
      case LoginMethod.ACCOUNT_NOT_FOUND:
        return this.renderAccountNotFoundStep()
      default:
        // Fallback: show email step if loginMethod is unknown
        return this.renderEmailStep()
    }
  }

  render() {
    return (
      <Card className="login pt-12">
        <div className="login__inner">
          <YumBack to="/" />
          <NotificationsWrapper />
          <Loader />
          {this.renderCurrentStep()}
        </div>
        {/*<LoginSidebar />*/}
        <WelcomeSidebar />
      </Card>
    )
  }
}
